import React from 'react';
import {useSelector, useStore} from 'react-redux';
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from '../../gameUi/GameButton';
import {MASKED_ICON_TONES, MaskedIcon} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {
  advanceFromSelectedUnit,
  advanceFromSleepingUnit,
  selectIsUnitTurnButtonDisabled,
  selectUnitTurnButtonMode,
  skipSelectedUnitTurn,
  UNIT_TURN_BUTTON_MODES
} from '../../../utils/unitAutoSelection/unitAutoSelectionCommands';
import {checkIfUnitAutoSelectionActive} from '../../../utils/unitAutoSelection/checkIfUnitAutoSelectionActive';
import './SkipUnitTurnButton.css';

const TITLES = {
  [UNIT_TURN_BUTTON_MODES.SKIP]: 'Пропустить ход отрядом (Пробел)',
  [UNIT_TURN_BUTTON_MODES.SLEEPING]: 'Отряд спит — к следующему (Пробел)',
  [UNIT_TURN_BUTTON_MODES.ADVANCE]: 'Следующий отряд (Пробел)',
};
// Спящий отряд, а переходить не к кому — или некому выбирать следующего
const DISABLED_SLEEPING_TITLE = 'Остальные отряды тоже спят или уже сходили';
const DISABLED_AUTO_SELECTION_OFF_TITLE = 'Автовыбор отрядов выключен в меню матча';

const COMMANDS = {
  [UNIT_TURN_BUTTON_MODES.SKIP]: skipSelectedUnitTurn,
  [UNIT_TURN_BUTTON_MODES.SLEEPING]: advanceFromSleepingUnit,
  [UNIT_TURN_BUTTON_MODES.ADVANCE]: advanceFromSelectedUnit,
};

/**
 * Кнопка пропуска хода отрядом в шапке футера, рядом с отменой (change
 * unit-auto-selection, design.md, решение 9). То же делает пробел. У отряда,
 * который уже спит (игрок выбрал его сам), кнопка сна ведет к следующему
 * отряду и заблокирована, только когда остальные тоже спят или сходили. После
 * выстрела или способности выбор остается на отряде ради результата, и кнопка
 * ведет к следующему отряду. Если пропускать нечего, кнопки нет
 */
const SkipUnitTurnButton = () => {
  const store = useStore();
  const mode = useSelector(selectUnitTurnButtonMode);
  const isDisabled = useSelector(selectIsUnitTurnButtonDisabled);
  const isAutoSelectionActive = useSelector(checkIfUnitAutoSelectionActive);

  if (!mode) {
    return null;
  }

  const disabledTitle = isAutoSelectionActive ? DISABLED_SLEEPING_TITLE : DISABLED_AUTO_SELECTION_OFF_TITLE;
  const title = isDisabled ? disabledTitle : TITLES[mode];
  const handleClick = () => {
    if (COMMANDS[mode](store)) {
      REGISTRY_SINGLETON.getSoundManager()?.playMenuButtonClick?.();
    }
  };

  return (
    <GameButton
      variant={GAME_BUTTON_VARIANTS.SUNK}
      size={GAME_BUTTON_SIZES.ICON}
      onClick={handleClick}
      disabled={isDisabled}
      className={'footer-heading-btn skip-unit-turn-button'}
      title={title}
      aria-label={title}
      data-tutorial-select={'skip_unit_turn_button'}
    >
      {mode !== UNIT_TURN_BUTTON_MODES.ADVANCE ? (
        <span className={'skip-unit-turn-button_zz'} aria-hidden={true}>
          <i className={'skip-unit-turn-button_z-small'}>z</i><i className={'skip-unit-turn-button_z-medium'}>z</i>Z
        </span>
      ) : (
        <MaskedIcon src={'/img/icons/arrow right.png'} alt={''} tone={MASKED_ICON_TONES.CONTROLS}/>
      )}
    </GameButton>
  );
};

export default SkipUnitTurnButton;
